<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les textes" />
            <LestextesDetails />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'

import LestextesDetails from './LestextesDetails.vue';

export default {
    name: 'PelerinagePage',
    components: {
        NavBar,
        PageTitle,
        LestextesDetails,
        FooterComp,
    }
}
</script>